<div class="history-container">
  <!-- Filtros -->
  <div class="filters-section">
    <mat-card class="filters-card">
      <mat-card-title class="filters-header">
        <div class="title-section">
          <mat-icon class="filter-icon">history</mat-icon>
          <span>Filtros do histórico</span>
        </div>
        <button
          mat-icon-button
          (click)="toggleFilters()"
          class="toggle-filters"
          [attr.aria-label]="
            filtersExpanded ? 'Recolher filtros do histórico' : 'Expandir filtros do histórico'
          "
          [attr.aria-expanded]="filtersExpanded"
        >
          <mat-icon>{{ filtersExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>
      </mat-card-title>

      @if (filtersExpanded) {
        <mat-card-content class="filters-content">
          <div class="filters-grid">
            <mat-form-field appearance="outline" class="filter-field">
              <mat-label>Data Início</mat-label>
              <input matInput [matDatepicker]="dataInicioPicker" [formControl]="dataInicio" />
              <mat-datepicker-toggle matSuffix [for]="dataInicioPicker"></mat-datepicker-toggle>
              <mat-datepicker #dataInicioPicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline" class="filter-field">
              <mat-label>Data Fim</mat-label>
              <input matInput [matDatepicker]="dataFimPicker" [formControl]="dataFim" />
              <mat-datepicker-toggle matSuffix [for]="dataFimPicker"></mat-datepicker-toggle>
              <mat-datepicker #dataFimPicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline" class="filter-field">
              <mat-label>Tipo de ação</mat-label>
              <mat-select [formControl]="tipoControl">
                @for (opcao of tipoOptions; track $index) {
                  <mat-option [value]="opcao.value">{{ opcao.description }}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="filter-field">
              <mat-label>Administrador</mat-label>
              <input matInput [formControl]="administradorControl" placeholder="Nome ou e-mail" />
              <mat-icon matSuffix>person</mat-icon>
            </mat-form-field>

            <mat-form-field appearance="outline" class="filter-field">
              <mat-label>Nº do pedido</mat-label>
              <input matInput [formControl]="buscaControl" placeholder="Ex.: 10231" />
              <mat-icon matSuffix>search</mat-icon>
              <mat-hint>Mostra as ações que afetaram este pedido</mat-hint>
            </mat-form-field>

            <!--<mat-form-field appearance="outline" class="filter-field">
              <mat-label>Nome do disparo</mat-label>
              <input
                matInput
                [formControl]="nomeControl"
                placeholder="Ex.: Convite evento setembro" />
              <mat-icon matSuffix>label</mat-icon>
              <mat-hint>Só encontra disparos pontuais</mat-hint>
            </mat-form-field>-->
          </div>

          <div class="filter-actions">
            <button mat-raised-button color="primary" (click)="carregar()" class="search-btn">
              <mat-icon>search</mat-icon>
              Pesquisar
            </button>
            <button mat-stroked-button (click)="limparFiltros()">
              <mat-icon>refresh</mat-icon>
              Limpar Filtros
            </button>
            <button mat-stroked-button (click)="exportar()" [disabled]="loading || !acoes.length">
              <mat-icon>file_download</mat-icon>
              Exportar histórico
            </button>
            <!--@if (modoLocal) {
              <button mat-stroked-button (click)="limparHistoricoLocal()">
                <mat-icon>delete_sweep</mat-icon>
                Limpar registro
              </button>
            }-->
          </div>
        </mat-card-content>
      }
    </mat-card>
  </div>

  @if (loading) {
    <div class="page-loader">
      <mat-spinner></mat-spinner>
    </div>
  } @else if (acoes.length === 0) {
    <p class="vazio">
      Nenhuma ação registrada para os filtros selecionados.
      @if (modoLocal) {
        <br />
        Altere o status de um pedido na tela de Pedidos e ele aparece aqui.
      }
    </p>
  } @else {
    <div class="acoes-lista">
      @for (acao of acoes; track acao.id_acao) {
        <mat-card class="acao-card">
          <div class="acao-linha" (click)="alternarDetalhe(acao)">
            <div class="col data">
              <mat-icon>{{
                acao.tipo === 'PROCESSAMENTO MASSIVO' ? 'published_with_changes' : 'mail'
              }}</mat-icon>
              <div>
                <strong>{{ acao.data }}</strong>
                <span class="tipo">{{ acao.tipo }}</span>
              </div>
            </div>

            <div class="col admin">
              <strong>{{ acao.administrador.nome }}</strong>
              <span>{{ acao.administrador.email }}</span>
            </div>

            <div class="col acao-descricao">
              <strong [matTooltip]="acao.acao">{{ acao.acao }}</strong>
              @if (acao.assunto) {
                <span class="assunto" [matTooltip]="acao.assunto">
                  Assunto: {{ acao.assunto }}
                </span>
              }
              <span>{{ acao.template || 'Sem e-mail' }}</span>
            </div>

            <div class="col numeros">
              <span class="chip total">{{ acao.quantidade }} registros</span>
              <span class="chip ok">{{ acao.sucessos }} enviados</span>
              @if (acao.falhas > 0) {
                <span class="chip erro">{{ acao.falhas }} falhas</span>
              }
            </div>

            <button
              mat-icon-button
              class="expandir"
              [attr.aria-label]="
                (expandidas.has(acao.id_acao)
                  ? 'Recolher detalhes da ação '
                  : 'Expandir detalhes da ação ') + acao.id_acao
              "
              [attr.aria-expanded]="expandidas.has(acao.id_acao)"
            >
              <mat-icon>
                {{ expandidas.has(acao.id_acao) ? 'expand_less' : 'expand_more' }}
              </mat-icon>
            </button>
          </div>

          @if (expandidas.has(acao.id_acao)) {
            <div class="acao-detalhe">
              @if (carregandoDetalhe.has(acao.id_acao)) {
                <div class="detalhe-loader">
                  <mat-spinner diameter="32"></mat-spinner>
                </div>
              } @else if (itensDe(acao.id_acao).length === 0) {
                <p class="vazio-detalhe">Nenhum registro detalhado para esta ação.</p>
              } @else {
                <table class="tabela-detalhe">
                  <thead>
                    <tr>
                      <th>Nº Pedido</th>
                      <th>Médico</th>
                      <!--<th>Status anterior</th>
                      <th></th>
                      <th>Status novo</th>-->
                      <th>E-mail</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (item of itensDe(acao.id_acao); track $index) {
                      <tr>
                        <td>{{ item.numero_pedido || '-' }}</td>
                        <td>{{ item.nome_medico }}</td>
                        <!--<td>
                          <span class="status-badge" [ngClass]="getStatusClass(item.status_anterior)">
                            {{item.status_anterior}}
                          </span>
                        </td>
                        <td class="seta"><mat-icon>arrow_forward</mat-icon></td>
                        <td>
                          <span class="status-badge" [ngClass]="getStatusClass(item.status_novo)">
                            {{item.status_novo}}
                          </span>
                        </td>-->
                        <td>
                          @if (item.email_enviado) {
                            <span class="email-ok">
                              <mat-icon>check_circle</mat-icon>
                              Enviado
                            </span>
                          } @else {
                            <span class="email-erro" [matTooltip]="motivoNaoEnvio(item)">
                              <mat-icon>error</mat-icon>
                              {{ motivoNaoEnvio(item) }}
                            </span>
                          }
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              }
            </div>
          }
        </mat-card>
      }
    </div>
  }
</div>
